import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
const Neet = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
      };
    useEffect(() => {
        const handleScroll = () => {
            const header = document.querySelector('.vistasHeader');
            if (window.scrollY > 50) {
                header?.classList.add('smallHeader');
            } else {
                header?.classList.remove('smallHeader');
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);
    var settings = {
        dots: false,
        infinite: true,
        fade: true,
        speed: 500,
        slidesToShow: 1,
        autoplaySpeed: 2000,
        autoplay: true,
        slidesToScroll: 1
    
      };
    return(
        <>
        <div className="vistasHeader">
            <div className="vistas-logo">
                <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/vistas-logo.png" className="img-fluid" alt="Lotus Valley School, Gurgaon" />
            </div>
            <div className="hamburger" onClick={toggleMenu}>
                {menuOpen ?'✖' : '☰'}
          
        </div>

        <ul className={`vistas-menu ${menuOpen ? 'open' : ''}`}>
                <li><Link to="/vistas">Introduction</Link></li>
                <li><Link to="/counselling-vistas">Counselling</Link></li>
                <li><Link to="/upcomingevt-vistas">Upcoming Events</Link></li>     
                <li><Link to="/update-vistas">Updates</Link></li>     
                <li><Link to="/spotlight-vistas">Spotlight</Link></li>     
                <li><Link to="/connect-vistas">Connect with Us</Link></li>     
            </ul>
        </div>
        <div className="slider-vistas">
        <Slider {...settings}>
          <div><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/vistas1.jpg" alt="Lotus Valley Gurgaon" className="img-fluid" /> </div>
          <div><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/vistas2.jpg" alt="Lotus Valley Gurgaon" className="img-fluid" /> </div>
          <div><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/vistas3.jpg" alt="Lotus Valley Gurgaon" className="img-fluid" /> </div>
          <div><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/vistas4.jpg" alt="Lotus Valley Gurgaon" className="img-fluid" /> </div>
          <div><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/vistas5.jpg" alt="Lotus Valley Gurgaon" className="img-fluid" /> </div>
          <div><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/vistas6.jpg" alt="Lotus Valley Gurgaon" className="img-fluid" /> </div>
          <div><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/vistas7.jpg" alt="Lotus Valley Gurgaon" className="img-fluid" /> </div>
          <div><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/vistas8.jpg" alt="Lotus Valley Gurgaon" className="img-fluid" /> </div> 
        </Slider>
        </div>
        <div className='padding-wid vistas_p'>
        <div class="container">
            <div class="text-center d-block">
                <h3 class="mx-auto text-black mb-4 font-play">NATIONAL ELIGIBILITY-CUM-ENTRANCE TEST (NEET)</h3>
            </div>
            <div class="table">
                            <table border="1" cellspacing="0" cellpadding="0" width="100%">
                                <tbody><tr>
                                    <td colspan="2"><strong>NEET 2024 Overview</strong></td>
                                </tr>
                                <tr>
                                    <td><strong>Aspects</strong></td>
                                    <td><strong>Information</strong></td>
                                </tr>
                                <tr>
                                    <td>Name of the Examination<strong></strong></td>
                                    <td>National Eligibility-Cum-Entrance Test</td>
                                </tr>
                                <tr>
                                    <td>Conducting Body<strong></strong></td>
                                    <td>National Testing Agency (NTA)<strong></strong></td>
                                </tr>
                                <tr>
                                    <td>Exam Frequency<strong></strong></td>
                                    <td>Once a year</td>
                                </tr>
                                <tr>
                                    <td>Courses Offered via Entrance Exam<strong></strong></td>
                                    <td>MBBS, BDS, AYUSH( BAMS,BUMS, BHMS) and BVSc</td>
                                </tr>
                                <tr>
                                    <td>Exam Duration<strong></strong></td>
                                    <td>The exam duration is 3 hours 20 minutes.<strong></strong></td>
                                </tr>
                                <tr>
                                    <td>Papers and Total Marks</td>
                                    <td>There are a total of 180 questions asked in the exam, 45 questions each from Physics, Chemistry Botany and Zoology.</td>
                                </tr>
                                <tr>
                                    <td>Total Questions</td>
                                    <td>180</td>
                                </tr>
                                <tr>
                                    <td>Marking Scheme</td>
                                    <td>
                                        <ul>
                                            <li>+4 for each correct response</li>
                                            <li>-1 for each incorrect response</li>
                                            <li>No marks for unattempted questions</li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Exam Mode</td>
                                    <td>&nbsp; Paper/Pencil based Test</td>
                                </tr>
                                <tr>
                                    <td>Colleges Accepting Exam Score</td>
                                    <td>AIIMS, JIPMER and State Medical Colleges</td>
                                </tr>
                                <tr>
                                    <td>Official Website</td>
                                    <td>https://neet.nta.nic.in/</td>
                                </tr>
                            </tbody></table>
                            <p>&nbsp;</p>
                        
                        </div>
                    
                </div>
        </div>
        <div className='copyright-vistas'>
                © 2024 All rights reserved with Lotus Valley School, Gurgaon
            </div>
        </>
    )

}
export default Neet